import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'changeModuleMedia';

const sanitise = ({...media}) => ({
    ...media
});

let _moduleMedia = [];
let _publishing = false;
let _fetching = 0;

let ModuleMediaStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return {remove: () => this.removeChangeListener(callback) };
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },

    isPublishing: () => _publishing,
    isFetching: () => _fetching > 0,
    getById: (id) => _moduleMedia.find((e) => !!e && e.id === id),
    add: (raw) => {
        const data = sanitise(raw);
        const mediaIndex = _moduleMedia.findIndex((e) => !!e && e.id === data.id);
        if (mediaIndex < 0) {
            _moduleMedia.push(data);
        } else {
            _moduleMedia[mediaIndex] = data;
        }
    },
    setPublishing: (publishing = true) => (_publishing = !!publishing),
    setFetching: (fetching = true) => (_fetching = _fetching + (fetching ? 1 : -1)),
});

ModuleMediaStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.MODULE_MEDIA_INFO_REQUEST:
            ModuleMediaStore.setFetching(true);
            ModuleMediaStore.emitChange();
            break;

        case ActionTypes.MODULE_MEDIA_INFO_SUCCESS:
            ModuleMediaStore.add(action.data);
            ModuleMediaStore.setFetching(false);
            ModuleMediaStore.emitChange();
            break;

        case ActionTypes.MODULE_MEDIA_INFO_FAILURE:
            ModuleMediaStore.setFetching(false);
            ModuleMediaStore.emitChange();
            break;

        case ActionTypes.MODULE_MEDIA_PUBLISH_REQUEST:
            ModuleMediaStore.setPublishing(true);
            ModuleMediaStore.emitChange();
            break;

        case ActionTypes.MODULE_MEDIA_PUBLISH_SUCCESS:
            // on successful publishing, this returns with the new details
            ModuleMediaStore.add(action.data);
            ModuleMediaStore.setPublishing(false);
            ModuleMediaStore.emitChange();
            break;

        case ActionTypes.MODULE_MEDIA_PUBLISH_FAILURE:
            ModuleMediaStore.setPublishing(false);
            ModuleMediaStore.emitChange();
            break;

        default:
            break;
    }

});

export default ModuleMediaStore;
